export const UPDATE_WIDGETS_SETTINGS_REQUEST = 'UPDATE_WIDGETS_SETTINGS_REQUEST';
export const UPDATE_WIDGETS_SETTINGS_SUCCESS = 'UPDATE_WIDGETS_SETTINGS_SUCCESS';
export const UPDATE_WIDGETS_SETTINGS_ERROR = 'UPDATE_WIDGETS_SETTINGS_ERROR';

export const GET_WIDGETS_SETTINGS_REQUEST = 'GET_WIDGETS_SETTINGS_REQUEST';
export const GET_WIDGETS_SETTINGS_SUCCESS = 'GET_WIDGETS_SETTINGS_SUCCESS';
export const GET_WIDGETS_SETTINGS_ERROR = 'GET_WIDGETS_SETTINGS_ERROR';